// Hooks
import { useEffect, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ConceptPaper from "./deliverable/conceptPaper";
import Proposal from "./deliverable/proposal";
import Report from "./deliverable/report";
import { useAuthContext } from "hooks/useAuthContext";

const BodyPage = ({ onSubmit }) => {
  const { user } = useAuthContext();
  const [activeTab, setActiveTab] = useState(0);

  // Function to get the greeting message based on the time
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  // State to store the greeting
  const [greeting, setGreeting] = useState(getGreeting());

  // Effect to update greeting dynamically
  useEffect(() => {
    const interval = setInterval(() => {
      setGreeting(getGreeting());
    }, 60000); // Updates every minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (user?.project?.stage === "Concept Paper") {
      setActiveTab(0);
    } else if (user?.project?.stage === "Proposal") {
      setActiveTab(1);
    } else {
      setActiveTab(2);
    }
  }, [user]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <MDBox>
      {/* Welcome Message */}
      <MDBox mx={3} mb={3}>
        <MDTypography variant="h6">
          {greeting}, {user?.last_name}.
        </MDTypography>
      </MDBox>

      {/* Navigation Tabs */}
      <Container>
        <Grid container item justifyContent="center" xs={12} lg={12} mx="auto">
          <AppBar position="static">
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              sx={{ backgroundColor: "grey" }}
            >
              <Tab label="Concept Paper" sx={{ fontWeight: "bold" }} />
              <Tab label="Project Execution" sx={{ fontWeight: "bold" }} />
              <Tab label="Final Report" sx={{ fontWeight: "bold" }} />
            </Tabs>
          </AppBar>
        </Grid>
      </Container>

      <MDBox mb={2} />

      {/* Render Components Based on Active Tab */}
      {activeTab === 0 && <ConceptPaper onSubmit={onSubmit} />}
      {activeTab === 1 && <Proposal onSubmit={onSubmit} />}
      {activeTab === 2 && <Report onSubmit={onSubmit} />}
    </MDBox>
  );
};

export default BodyPage;
